/* ============================================================================
   sf-set-kombis.js — "Fertig kombiniert" im Set-Look (sections/sf-set-kombis.liquid, 01.10.2026)
   Sorte waehlen -> Kachelbild, Einzelpreis, Summe und Versandzeile aktualisieren.
   Ein Klick legt alle Produkte der Kombi (je 1 Stueck) mit EINEM /cart/add.js in den Warenkorb;
   PEAK-Zeilen tragen _sf_peak=1 (assets/stl-order-type-guard.js laesst sie neben einer Vorbestellung zu),
   wie bisher assets/sf-peak.js. Danach Warenkorb-Schublade (cartUpdate) oder Warenkorbseite.
   ============================================================================ */
(function () {
  'use strict';
  if (window.__sfskReady) return;
  window.__sfskReady = true;

  var ERR = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
  var NA = 'Das ist gerade nicht bestellbar. Bitte versuch es später noch einmal.';

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    var v = (Math.round(Number(cents) || 0) / 100).toFixed(2).split('.');
    return '€' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + v[1];
  }
  function num(v) { var n = parseInt(v, 10); return isNaN(n) ? 0 : n; }

  /** Auswahl je Produktzeile: gewaehlter Chip oder feste Variante */
  function picks(card) {
    return [].map.call(card.querySelectorAll('[data-sfsk-item]'), function (li) {
      var idx = li.getAttribute('data-sfsk-item');
      var chip = card.querySelector('input[data-sfsk-pick="' + idx + '"]:checked');
      var fixed = li.querySelector('input[data-sfsk-fixed]');
      var id = chip ? chip.value : fixed ? fixed.value : '';
      var cents = chip ? num(chip.getAttribute('data-cents')) : num(li.getAttribute('data-cents'));
      return { li: li, idx: idx, id: id, cents: cents, peak: li.getAttribute('data-peak') === '1', chip: chip };
    });
  }

  function sync(card) {
    var total = 0;
    picks(card).forEach(function (p) {
      total += p.cents;
      var price = p.li.querySelector('[data-sfsk-price]');
      if (price) price.textContent = money(p.cents);
      var flavor = p.li.querySelector('[data-sfsk-flavor]');
      if (flavor && p.chip) flavor.textContent = p.chip.getAttribute('data-label') || flavor.textContent;
      var src = p.chip && p.chip.getAttribute('data-img');
      var img = card.querySelector('img[data-sfsk-img="' + p.idx + '"]');
      if (img && src && img.getAttribute('data-now') !== src) {
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = src;
        img.setAttribute('data-now', src);
      }
    });
    var sum = card.querySelector('[data-sfsk-sum]');
    if (sum) sum.textContent = money(total);
    var sub = card.querySelector('[data-sfsk-sub]');
    var free = num(card.getAttribute('data-peak-free')) || 5000;
    if (sub) sub.textContent = sub.getAttribute(total >= free ? 'data-above' : 'data-below') || sub.textContent;
  }

  function busy(btn, on) {
    if (on) { btn.setAttribute('aria-busy', 'true'); btn.setAttribute('aria-disabled', 'true'); }
    else { btn.removeAttribute('aria-busy'); btn.removeAttribute('aria-disabled'); }
  }

  function add(btn) {
    var card = btn.closest('[data-sfsk-card]');
    if (!card || btn.getAttribute('aria-busy') === 'true') return;
    var msg = card.querySelector('[data-sfsk-msg]');
    if (msg) msg.textContent = '';
    var list = picks(card);
    if (!list.length || list.some(function (p) { return !p.id; })) { if (msg) msg.textContent = NA; return; }
    var items = list.map(function (p) {
      var it = { id: num(p.id), quantity: 1 };
      if (p.peak) it.properties = { _sf_peak: '1' };
      return it;
    });

    // Vorbestell-Warenkorb (assets/stl-order-type-guard.js): nur PEAK darf daneben liegen
    var guard = window.stlOrderTypeGuard;
    if (guard && guard.state && guard.state.hasPreorder && items.some(function (i) { return !i.properties; })) {
      var gcfg = window.__stlOrderTypeGuardConfig || {};
      if (msg) msg.textContent = gcfg.message || 'Vorbestellungen und sofort verfügbare Artikel müssen getrennt bestellt werden.';
      return;
    }

    var theme = window.theme || {};
    var routes = theme.routes || {};
    var addUrl = routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js';
    if (/\.js\.js$/.test(addUrl)) addUrl = addUrl.slice(0, -3);
    var cartUrl = routes.cart_url || '/cart';
    var drawer = document.querySelector('cart-drawer');
    var pageCart = theme.settings && theme.settings.cartType === 'page';
    var sections = [];
    if (drawer && !pageCart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
    }
    var label = btn.getAttribute('data-label') || btn.textContent;
    btn.setAttribute('data-label', label);
    busy(btn, true);
    btn.textContent = 'Wird hinzugefügt';

    fetch(addUrl, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { j = j || {}; j.__ok = r.ok; return j; });
      })
      .then(function (res) {
        // /cart/add antwortet bei Fehlern mit 422, teils ohne "status"; der Aufruf ist dann atomar (nichts hinzugefuegt)
        if (!res.__ok || res.status) {
          var d = res.description;
          if (!d || /Variante nicht finden|Warenkorb-Fehler/i.test(d)) d = NA;
          throw new Error(d);
        }
        if (!drawer || pageCart || !theme.pubsub) { window.location.href = cartUrl; return 'leave'; }
        return fetch(cartUrl + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = res.sections;
            theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sf-set-kombis', cart: cart });
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: res } }));
            if (typeof drawer.show === 'function') drawer.show(btn);
          });
      })
      .then(function (state) {
        if (state === 'leave') return;
        busy(btn, false);
        btn.textContent = label;
      })
      .catch(function (err) {
        busy(btn, false);
        btn.textContent = label;
        if (msg) msg.textContent = (err && err.message) || ERR;
      });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-sfsk] [data-sfsk-card]').forEach(sync);
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('input[data-sfsk-pick]');
    if (!input) return;
    var card = input.closest('[data-sfsk-card]');
    if (card) {
      var msg = card.querySelector('[data-sfsk-msg]');
      if (msg) msg.textContent = '';
      sync(card);
    }
  });
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-sfsk-add]');
    if (btn) { e.preventDefault(); add(btn); }
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    document.querySelectorAll('[data-sfsk-add][aria-busy]').forEach(function (b) {
      busy(b, false);
      if (b.getAttribute('data-label')) b.textContent = b.getAttribute('data-label');
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
})();
